function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import _ from "lodash";
import SignatureCanvas from "react-signature-canvas";

var ReactSignatureCanvasField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactSignatureCanvasField, _Component);

  function ReactSignatureCanvasField(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = _extends({}, props, {
      width: props.uiSchema["ui:options"] && props.uiSchema["ui:options"].width || 400,
      height: props.uiSchema["ui:options"] && props.uiSchema["ui:options"].height || 150,
      value: props.formData || ""
    });
    return _this;
  }

  var _proto = ReactSignatureCanvasField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.state.readonly && this.sigCanvas) this.sigCanvas.fromDataURL(this.state.formData);
  };

  _proto._clear = function _clear(e) {
    e.preventDefault();
    var confirmed = confirm("Clear the signature?");

    if (confirmed) {
      this.sigCanvas.clear();
      this.setState({
        value: ""
      });
      this.state.onChange();
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: "relative",
        width: this.state.width + 41,
        minHeight: this.state.height + 40
      }
    }, !this.state.readonly ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SignatureCanvas, {
      ref: function ref(_ref) {
        _this2.sigCanvas = _ref;
      },
      penColor: "black",
      canvasProps: {
        width: this.state.width,
        height: this.state.height,
        className: "sigCanvas",
        style: {
          border: "#ddd 3px dashed",
          borderRadius: 4
        }
      },
      backgroundColor: "#fafafa",
      onEnd: function onEnd(value) {
        _this2.state.onChange(_this2.sigCanvas.toDataURL(value));

        _this2.setState({
          value: _this2.sigCanvas.toDataURL(value)
        });
      }
    }), /*#__PURE__*/React.createElement("input", {
      type: "text",
      style: {
        border: 0,
        height: 1,
        width: 1
      },
      value: this.state.value,
      onChange: function onChange(event) {
        return _this2.state.value;
      },
      readOnly: true,
      required: this.state.required
    }), this.sigCanvas && !this.sigCanvas.isEmpty() ? /*#__PURE__*/React.createElement("button", {
      className: "btn btn-secondary d-print-none",
      style: {
        position: "absolute",
        right: 0,
        top: 0,
        height: this.state.height + 6,
        fontSize: 16,
        fontWeight: "700",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderWidth: 3
      },
      onClick: this._clear.bind(this)
    }, "\xD7") : null) : this.state.formData ? /*#__PURE__*/React.createElement("img", {
      style: {
        minHeight: this.state.height
      },
      src: this.state.formData
    }) : /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: this.state.height,
        fontWeight: "700",
        lineHeight: this.state.height + "px",
        color: "#666",
        backgroundColor: "#fafafa",
        textAlign: "center"
      }
    }, "No Signature"), /*#__PURE__*/React.createElement("div", {
      className: "sigSalutation"
    }, /*#__PURE__*/React.createElement("h6", {
      style: {
        paddingTop: 10,
        marginTop: 15,
        borderTop: "#444 1px solid"
      }
    }, this.state.schema.title)));
  };

  return ReactSignatureCanvasField;
}(Component);

export default ReactSignatureCanvasField;